import { postFetch } from '../fetch';

import { apiConfig } from '../config';

interface PostLinkCourseContainerToCourseRequestBody {
    courseId: number;
    courseContainerSlugs: string[];
}

export function postLinkCourseContainerToCourse(body: PostLinkCourseContainerToCourseRequestBody):Promise<any> {
    const { courseId, courseContainerSlugs } = body;
    const { apiPostLinkCourseContainerToCourse } = apiConfig.getStaticUrls();

    return postFetch(`${apiPostLinkCourseContainerToCourse}${courseId}`, {
        course_container_slugs: courseContainerSlugs,
    });
}
